import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62149570"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center mt-0" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "ma-0" }
const _hoisted_4 = { key: 0 }

import { inject, onMounted, ref, computed } from "vue";
import User from "@/models/user";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import type { FormInstance } from "element-plus";
import { EventParticipant } from "@/vue-core/models/EventParticipant.model";
import { loaderDone, loaderStart } from "@/services/Loader";
import useBreakpoints from "@/services/Breakpoints";


export default /*#__PURE__*/_defineComponent({
  __name: 'RegisterCard',
  emits: ["methodToContinueRegister"],
  setup(__props, { emit }) {

const drawer = ref(false);
const store = useStore();
const route = useRoute();
const eventData = computed(() => store.getters["user/eventData"]);


const formRegisterRef = ref<FormInstance>();
const formRegister = User.getRegisterCardForm();
const formRegisterProps = User.getRegisterCardProps();
const rules = User.getRegisterCardRules();

const formLoginRef = ref<FormInstance>();
const formLogin = User.getloginForm();
const formLoginProps = User.getloginProps();
const formLoginRules = User.getloginRules();

const { type } = useBreakpoints();

async function login() {
  if (await formLoginRef.value.validate()) {
    loaderStart();
    await store.dispatch("user/passwordEmailActionCard", {
      email: formLogin.email,
      password: formLogin.password,
      eventID: route.params.eventID,
    });
    loaderDone();
    closeAndResetFields();
    emit("methodToContinueRegister");
  }
}
async function registerUser() {
  if (await formRegisterRef.value.validate()) {
    loaderStart();
    const userData: EventParticipant = {
      email: formRegister.email,
      firstName: formRegister.firstName,
      lastName: formRegister.lastName,
      secondLastName: formRegister.secondLastName,
      fullName: `${formRegister.firstName} ${formRegister.lastName} ${formRegister.secondLastName}`,
      registerDate: new Date(),
      profileImage: "",
    };
    const userCredential = await store.dispatch("user/registerUser", {
      email: formRegister.email,
      password: formRegister.password,
    });
    if (userCredential) {
      loaderStart();
      userData.uid = userCredential.uid;
      await store.dispatch("event/registerParticipant", userData);
      userData.eventID = route.params.eventID as string;
      await store.dispatch("event/saveCardEventParticipantData", userData);
      loaderDone();
      closeAndResetFields();
      emit("methodToContinueRegister");
    }
    loaderDone();
  }
}
async function closeAndResetFields() {
  await formRegisterRef.value.resetFields();
  await formLoginRef.value.resetFields();
  drawer.value = false;
}
function selectWidth(breakpoint) {
  switch (breakpoint) {
    case "lg":
      return "50%";
    case "md":
      return "65%";
    default:
      return "80%";
  }
}

onMounted(() => {
  const emitter: any = inject("emitter");
  emitter.on("toggleDialogRegister", (value) => {
    drawer.value = value;
  });
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: drawer.value,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((drawer).value = $event)),
    "custom-class": "card-register",
    "before-close": closeAndResetFields,
    width: selectWidth(_unref(type))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 13,
            xl: 14
          }, {
            default: _withCtx(() => [
              _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t("cardRegister.register")), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("cardRegister.description")), 1),
              _createVNode(_component_el_form, {
                model: _unref(formRegister),
                rules: _unref(rules),
                ref_key: "formRegisterRef",
                ref: formRegisterRef,
                "label-position": "top",
                class: "card__register"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('register.email'),
                    prop: "email"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, _mergeProps({
                        modelValue: _unref(formRegister).email,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formRegister).email) = $event))
                      }, _unref(formRegisterProps).email), null, 16, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('register.password'),
                    prop: "password"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, _mergeProps({
                        modelValue: _unref(formRegister).password,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formRegister).password) = $event))
                      }, _unref(formRegisterProps).password), null, 16, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('register.confirmPassword'),
                    prop: "confirmPassword"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, _mergeProps({
                        modelValue: _unref(formRegister).confirmPassword,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formRegister).confirmPassword) = $event))
                      }, _unref(formRegisterProps).confirmPassword), null, 16, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('register.firstName'),
                    prop: "firstName"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, _mergeProps({
                        modelValue: _unref(formRegister).firstName,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formRegister).firstName) = $event))
                      }, _unref(formRegisterProps).firstName), null, 16, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('register.lastName'),
                    prop: "lastName"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, _mergeProps({
                        modelValue: _unref(formRegister).lastName,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formRegister).lastName) = $event))
                      }, _unref(formRegisterProps).lastName), null, 16, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('register.secondLastName'),
                    prop: "secondLastName"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, _mergeProps({
                        modelValue: _unref(formRegister).secondLastName,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(formRegister).secondLastName) = $event))
                      }, _unref(formRegisterProps).secondLastName), null, 16, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }, 8, ["model", "rules"]),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  class: "primary__color__button",
                  onClick: registerUser
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("cardRegister.save")), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 2,
            xl: 2,
            class: "d-flex justify-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_divider, {
                direction: "vertical",
                style: {"height":"100%"}
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 9,
            xl: 8,
            class: "d-flex align-center justify-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { class: "box-card text-center" }, {
                default: _withCtx(() => [
                  _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("login.loginTitle")), 1),
                  (eventData.value.themeSettings.logoURL)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(_component_el_image, {
                          class: "logo-app",
                          src: eventData.value.themeSettings.logoURL,
                          fit: "contain"
                        }, null, 8, ["src"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form, {
                    model: _unref(formLogin),
                    rules: _unref(formLoginRules),
                    ref_key: "formLoginRef",
                    ref: formLoginRef
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { prop: "email" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, _mergeProps(_unref(formLoginProps).email, {
                            modelValue: _unref(formLogin).email,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(formLogin).email) = $event))
                          }), null, 16, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { prop: "password" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, _mergeProps(_unref(formLoginProps).password, {
                            modelValue: _unref(formLogin).password,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(formLogin).password) = $event)),
                            onKeyup: _withKeys(login, ["enter"])
                          }), null, 16, ["modelValue", "onKeyup"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model", "rules"]),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: login,
                    class: "secondary__color__button"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("login.loginButton")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "width"]))
}
}

})